// extracted by mini-css-extract-plugin
module.exports = {"screenshotInstructions":"TextScreenshots-module__screenshotInstructions___3A91K"};